<template>
  <!-- 分页器 -->
  <div class="page-container clearfix">
    <!--pc端分页-->
    <div id="page" class="hidden-xs col-sm-12">
      <ul>
        <li class="prev" :class="{disable:current==1}" @click="prev"><label>&nbsp;<label class="glyphicon glyphicon-chevron-left"></label>上一頁&nbsp;</label></li>
        <li v-for="index in pages" @click="goPage(index)" :class="{'active':current==index}"><span
          v-cloak>{{index}}</span></li>
        <li class="next" :class="{disable:current==total}" @click="next"><label>&nbsp;下一頁<label class="glyphicon glyphicon-chevron-right"></label>&nbsp;</label></li>
      </ul>
    </div>
    <!--移动端分页-->
    <div id="s-page" class="visible-xs col-xs-12">
      <span class="prev col-xs-4" :class="{disable:current==1}" @click="prev"><span class="glyphicon glyphicon-chevron-left"></span>上一頁</span>
      <div class="center-page col-xs-4" @click="showAlert = !showAlert"><span>{{current}}/{{total}}</span><span
        class="down">〉</span></div>
      <span class="next col-xs-4" :class="{disable:current==total}" @click="next">下一頁<span class="glyphicon glyphicon-chevron-right"></span></span>
      <div class="s-page-body" v-if="showAlert" @click="colse">
        <div class="s-page-list">
          <div class="floow" @click.stop="isOk">完成</div>
          <ul style="margin-top: 40px;">
            <li v-for="index in pages" @click.stop="thePage=index" :class="{'s-active':thePage==index}"><span>{{index}}/{{total}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

// 解决遮罩层滚动穿透问题，分别在遮罩层弹出后和关闭前调用
const ModalHelper = ((bodyCls) => {
  let scrollTop
  return {
    afterOpen: function () {
      scrollTop = document.scrollingElement.scrollTop
      document.body.classList.add(bodyCls)
      document.body.style.top = -scrollTop + 'px'
    },
    beforeClose: function () {
      document.body.classList.remove(bodyCls)
      document.scrollingElement.scrollTop = scrollTop
    }
  }
})('dialog-open');
export default {
  name: 'MoPaging',
  props: {
    totalPages: Number    //从父组件传递总页数
  },
  data () {
    return {
      current: 1, //当前页
      total: this.totalPages,   //总页数
      showItem: 10,  //最多展示的页码数
      showAlert: false,
      thePage: 1    // 移动端选中的页
    }
  },
  computed: {
    pages () {
      var page = [];//显示页码
      // 思想：用当前激活页面驱动页面显示的分别
      if (this.current < this.showItem) {//当前页小于最大页码数（showItem），区分总页数是否达到最大页码数
        //获取总页数和最大页码数较小的值
        var i = Math.min(this.total, this.showItem);
        while (i) {
          //通过page的数组值显示页码
          page.unshift(i--);
        }
      } else {  // 当前页面大于最大页码数（showItem）时，区分显示的页码规则
        var pagestart = this.current - Math.floor(this.showItem / 2);// 获取显示的页码第一位页码（默认当前页居中）
        var i = this.showItem;//用来显示多少（i）个页码
        if (pagestart > (this.total - this.showItem)) {//第一个页码如果大于总页数减去展示的页码数，则当前页不能居中
          pagestart = (this.total - this.showItem) + 1;//应该显示的第一个页码数
        }
        while (i--) {
          //通过page的数组值显示页码
          page.push(pagestart++);
        }
      }
      this.$emit('get-list', this.current)		//向父组件传递页码
      return page
    }
  },
  mounted: function () {
    // console.log(this.totalPages);
  },
  watch: {
    // 監聽分頁彈出框
    showAlert: function (val, oldVal) {
      if (val === true) {
        ModalHelper.afterOpen()
      } else {
        ModalHelper.beforeClose()
      }
    }
  },
  methods: {
    goPage: function (index) {
      this.goTop()
      this.current = index
    },
    colse: function () {
      this.current = this.thePage
      this.showAlert = false
      // this.$emit('get-list', this.current)
    },
    isOk: function () {
      this.colse()
      this.goTop()
    },
    prev: function () {
      this.current--
      this.goTop()
    },
    next: function () {
      this.current++
      this.goTop()
    }
  }
}
</script>
<style scoped>
  .page-container {

  }

  #page {
    text-align: center;
    position: relative;
    margin-top: 10%;
  }

  #page ul {
    padding-left: 10px;
    display: inline-block;
    font-family: PingFangSC-Regular;
    border: 1px solid #526ADD;
    border-radius: 100px;
    font-size: 18px;
    color: #526ADD;

  }

  #page ul li {
    display: inline-block;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-right: 10px;
  }

  .prev {
    margin-right: 30px;
  }

  .next {
    /*margin-left: 30px;*/
    margin-right: 30px;
  }

  #page span {
    display: inline-block;
    min-width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }

  #page span:hover {
    color: #FFFFFF;
    background: #526ADD;
    border-radius: 15px;
    cursor: pointer;
  }

  #page label {
    cursor: pointer;
  }

  /*#page .next {*/
    /*color: #526ADD;*/
    /*background: #ffffff;*/
  /*}*/

  [v-cloak] {
    display: none;
  }

  .active {
    color: #FFFFFF;
    background: #526ADD;
    border-radius: 20px;
    pointer-events: none;
  }

  .disable {
    background-color: #fff;
    color: #505050;
    pointer-events: none;
    cursor: not-allowed;
    opacity: .75
  }

  #s-page {
    font-size: 12px;
    padding: 0px;
    margin-top: 20px;
    color: #526add;
  }

  #s-page ul {
    color: #000;
  }

  #s-page ul li {
    list-style-type: none;
  }

  #s-page span {
    display: inline-block;
    min-width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;

  }

  #s-page .prev {
    margin: 0px;
  }

  #s-page .next {
    margin-left: 0px;
    margin-right: 0px;
  }

  .center-page {
    display: inline;
    text-align: center;
  }

  .down {
    transform: rotate(90deg);
  }

  .s-page-body {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /*background: #4A4A4A url('@/assets/logo.png') no-repeat center;*/
    background: rgba(0, 0, 0, 0.42);
    z-index: 1;
    transition: all .3s ease-in-out;
    overflow: hidden;
  }

  .s-page-list {
    position: fixed;
    text-align: center;
    width: 200px;
    height: 300px;
    left: 25%;
    top: 25%;
    background: #ffffff;
    border-radius: 20px;
    overflow-y: scroll;
    background-image: linear-gradient(-180deg, rgba(209, 212, 221, 0.00) 0%, #D1D4DD 79%);
  }

  .s-page-list .floow {
    position: fixed;
    text-align: center;
    line-height: 40px;
    top: 25%;
    left: 25%;
    background: #EFF0F2;
    border-radius: 8px 8px 0 0;
    width: 200px;
    height: 40px;
    font-size: 16px;
  }

  .s-page-list::-webkit-scrollbar {
    display: none;
  }

  .s-page-list ul {
    padding: 0px;
    text-align: center;
  }

  .s-active{
    border-top:solid 1px #6d7074;
    border-bottom: solid 1px #6d7074;
    /*border:solid 1px #6d7074;*/
    border-radius: 5px;
  }

  @media (min-height: 1200px) {
    li {
      margin-right: 5px;
    }

    .prev {
      margin-right: 10px;
    }

    .next {
      margin-left: 10px;
      /*margin-right: 30px;*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages.vue